import commonApi from '@/api/api.common'
import productApi from '@/api/api.product'
import faultApi from '@/api/api.fault'
import i18n from '@/locales/index'
export default [
  {
    type: 'input',
    placeholder: i18n.t('Fault.deviceCode'),
    filed: 'deviceCode',
    default: ''
  },
  {
    type: 'select',
    placeholder: i18n.t('Fault.productModel'),
    filed: 'productId',
    default: '',
    multiple: true,
    clearable: true,
    query: `${productApi.product_select}?type=steamingOven`
  },
  {
    type: 'select',
    placeholder: i18n.t('Fault.errorReason'),
    filed: 'fault',
    default: '',
    clearable: true,
    query: faultApi.faultCode_select
  },
  {
    type: 'datepicker',
    placeholder: '',
    default: [],
    filed: 'daterange',
    params: {
      start: 'startTime',
      end: 'endTime'
    }
    // startplh: i18n.t('APPUser.createTimeStart'),
    // endplh: i18n.t('APPUser.createTimeEnd')
  }
]
